import type { Severity, Status } from '../api/types';

export function SeverityBadge({ severity }: { severity: Severity }) {
  return <span className={`badge severity-${severity}`}>{severity}</span>;
}

export function StatusBadge({ status }: { status: Status }) {
  return <span className={`badge status-${status}`}>{status.replace('_', ' ')}</span>;
}

export function Tag({ children }: { children: string }) {
  return <span className="tag">{children}</span>;
}
